<template>
    <div class="container px-2 py-2">
        <h4 class="mt-3"><strong>Registrar familia de materia prima</strong></h4>
        <form action="" class="w-75 mx-auto">
            <div class="row aling-items-center mt-3 mb-3">
                <div class="col-sm-5">
                    <label for="rawMattype">Línea:</label>
                </div>
                <div class="col-sm-5">
                    <select class="form-select" id="rawMatType" v-model="rawMatType">
                        <option value="0" selected>Seleccione una opción...</option>
                        <option value="lam">Láminas</option>
                        <option value="perf">Perfiles</option>
                        <option value="tub">Tubos</option>
                    </select>
                </div>
            </div>
            <div class="row aling-items-center mt-3 mb-3">
                <div class="col-sm-5">
                    <label for="rawMatName">Nombre de la materia prima:</label>
                </div>
                <div class="col-sm-5">
                    <input type="text" v-model="rawMatName" class="form-control" id="rawMatName" />
                </div>
            </div>
            <div class="row aling-items-center mt-3 mb-3">
                <div class="col-sm-5">
                    <label for="rawMatName">Descripción de la materia prima:</label>
                </div>
                <div class="col-sm-5">
                    <textarea type="text" v-model="rawMatDescrip" class="form-control" id="rawMatDescrip"></textarea>
                </div>
            </div>
            <div class="row aling-items-center mt-3 mb-3">
                <div class="col-sm-5">
                    <label for="rawMatImage">Imagen representativa de la materia prima: </label>
                </div>
                <div class="col-sm-5">
                    <input type="file" class="form-control" id="rawMatImage" ref="file" @change="previewFile" />
                </div>
            </div>
            <div class="row aling-items-center mt-3 mb-3">
                <div class="col-sm-5">
                    <label for="rawMatvalue">Orden de la materia prima: </label>
                </div>
                <div class="col-sm-5">
                    <input type="number" v-model="rawMatOrder" class="form-control" id="rawMatOrder" step="1" min="0" />
                </div>
            </div>
            <div>
                <button class="btn btn-danger my-2" @click.prevent="registerRawMaterial">
                    Guardar materia prima
                </button>
            </div>
        </form>
    </div>
</template>
<script>
import axios from "axios";
export const RUTA_SERVIDOR = process.env.VUE_APP_RUTA_BACKEND;
export default {
    data() {
        return {
            rawMatType: "",
            rawMatName: "",
            rawMatImg: null,
            rawMatOrder: 0,
            //Variables para trabajar con la imagen
            imageFile: undefined,
            currentFile: undefined,
        };
    },
    methods: {
        previewFile(event) {
            this.imageFile = this.$refs.file.files;
            // console.log(this.imageFile);
            this.currentFile = this.imageFile.item(0);
            // console.log(this.currentFile);
        },
        async registerRawMaterial() {
            if (
                this.rawMatType === "" ||
                this.rawMatName === "" ||
                this.rawMatDescrip === "" ||
                this.rawMatOrder == 0 ||
                this.currentFile == undefined
            ) {
                alert("Alguno de los campos está vácio, no se puede crear la materia prima.");
            } else {
                let formData = new FormData();
                formData.append("rawMat_type", this.rawMatType);
                formData.append("rawMat_name", this.rawMatName);
                formData.append("rawMat_descrip", this.rawMatDescrip);
                formData.append("rawMat_image", this.currentFile);
                formData.append("rawMat_order", this.rawMatOrder);
                try {
                    let res = await axios.post(
                        RUTA_SERVIDOR + "api/rawMaterial/create",
                        formData,
                        {
                            headers: {
                                "Content-Type": "multipart/form-data",
                                Authorization: "Bearer " + localStorage.getItem("token"),
                            },
                        }
                    );
                    console.log(res.data);
                    if (!res.data) {
                        console.log("There has been a different error with the data.");
                    } else {
                        alert("Materia prima" + this.rawMatName + " creada con exito!");
                        this.cleanfields();
                    }
                } catch (err) {
                    console.log(`There has been an error ${err}`);
                }
            }
        },
        cleanfields() {
            this.rawMattype = "0";
            this.rawMatName = "";
            this.rawMatDescrip = "";
            this.rawMatOrder = 0;
        },
    },
};
</script>
<style scoped></style>